import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Selectors from '../redux/selectors';
import { initLmsAction } from '../redux/actions';
import { SearchBarPlaceholder } from '../../shared/components/SearchBarPlaceholder/SearchBarPlaceholder';
import SearchBarContainer from './SearchBarContainer';
import SortBarContainer from './SortBarContainer';
import ContentContainer from './ContentContainer';
import { MessageBanner } from '../components/MessageBanner';

const MainContainer = (props) => {
  const { dispatch, hasInitialized, searchIsOpen, texts } = props;

  useEffect(() => {
    if (!hasInitialized) {
      dispatch(initLmsAction());
    }
  }, [hasInitialized]);

  if (!hasInitialized) {
    return <SearchBarPlaceholder searchInitialOpen={searchIsOpen} />;
  }
  const showMessageBanner = texts?.messageBannerText;

  return (
    <>
      <SearchBarContainer texts={texts} />
      {
        showMessageBanner && <MessageBanner text={texts?.messageBannerText} />
      }
      <SortBarContainer texts={texts} />
      <ContentContainer texts={texts} />
    </>
  );
};

MainContainer.propTypes = {
  dispatch: PropTypes.func,
  hasInitialized: PropTypes.bool,
  texts: PropTypes.object,
  searchIsOpen: PropTypes.bool,
};

function mapStateToProps(state) {
  const query = Selectors.getQueryParams(state);

  return {
    hasInitialized: Selectors.hasInitialized(state),
    texts: Selectors.getTexts(state),
    searchIsOpen: query.search,
    selectedOrderBy: query.orderBy,
  };
}

export const ConnectedMainContainer = connect(mapStateToProps)(MainContainer);

export default ConnectedMainContainer;
